/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Badge, FlexColumn, FlexRow, Typography } from 'design-system';
import {
  LockIcon,
  ShieldIcon,
} from 'design-system/components/Icons';
import LearningShell from '../../components/LearningShell';
import OutcomeFooterNote from '../../components/OutcomeFooterNote';

export default function LockedStep({ course, quizResult, passMarkPercent }) {
  const intl = useIntl();

  return (
    <LearningShell
      layout="outcome"
      showWarning={false}
    >
      <FlexColumn align="center" fullWidth className="ld-outcome">
        <FlexColumn align="center" fullWidth gap="var(--ds-space-4)" className="ld-outcome__hero">
          <FlexRow
            align="center"
            justify="center"
            fullWidth={false}
            className="ld-outcome__icon ld-outcome__icon--locked"
          >
            <LockIcon size={24} className="ds-icon--color-error" aria-hidden />
          </FlexRow>

          <Badge variant="negative" emphasis="subtle" size="md" dot>
            {intl.formatMessage({ id: 'ld-not-passed' })}
          </Badge>

          <Typography component="h1" variant="headingMedium" fontWeight="semibold" color="ui-emphasis" className="ld-outcome__title">
            {intl.formatMessage({ id: 'ld-locked-title' })}
          </Typography>

          <Typography component="p" variant="bodyMedium" color="ui-subtle" className="ld-outcome__description">
            {intl.formatMessage(
              { id: 'ld-locked-description' },
              { score: `${quizResult.scorePercent}%`, passMark: passMarkPercent },
            )}
          </Typography>
        </FlexColumn>

        <FlexColumn align="start" fullWidth className="ld-surface ld-outcome__panel ld-outcome__panel--locked">
          <FlexRow align="start" fullWidth gap="var(--ds-space-3)">
            <ShieldIcon size={20} className="ld-outcome__panel-icon" aria-hidden />
            <FlexColumn align="start" fullWidth gap="var(--ds-space-2)">
              <Typography component="h2" variant="bodyMedium" fontWeight="semibold" className="ld-outcome__panel-title">
                {intl.formatMessage({ id: 'ld-speak-to-manager' })}
              </Typography>
              <Typography component="p" variant="bodySmall" className="ld-outcome__panel-copy">
                {intl.formatMessage(
                  { id: 'ld-locked-manager-copy' },
                  { courseTitle: course.title },
                )}
              </Typography>
            </FlexColumn>
          </FlexRow>
        </FlexColumn>

        <OutcomeFooterNote>
          {intl.formatMessage({ id: 'ld-close-window' })}
        </OutcomeFooterNote>
      </FlexColumn>
    </LearningShell>
  );
}

LockedStep.propTypes = {
  course: PropTypes.shape({
    description: PropTypes.string,
    logoSrc: PropTypes.string,
    title: PropTypes.string.isRequired,
  }).isRequired,
  quizResult: PropTypes.shape({
    scorePercent: PropTypes.number.isRequired,
  }).isRequired,
  passMarkPercent: PropTypes.number.isRequired,
};
